import * as React from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { itIT } from '@mui/x-data-grid/locales';

const paginationModel = { page: 0, pageSize: 15 };

export default function TableSnapshotDepositi({ val = [], campaignName }) {
  const columns = React.useMemo(() => [
    { field: 'id', headerName: 'RowID', width: 80 },
    { field: 'garage', headerName: 'Deposito', width: 280, flex: 1, minWidth: 220 },
    { field: 'regione', headerName: 'Regione', width: 120 },
    { field: 'citta', headerName: 'Città', width: 140 },

    {
      field: 'completed', headerName: 'Completati', width: 130, headerAlign: 'center', align: 'center',
      renderCell: (params) => (
        <Box sx={{ backgroundColor: '#d0f2d5', width: '100%', height: '100%',
          display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {params?.value ?? '—'}
        </Box>
      ),
    },
    {
      field: 'inProgress', headerName: 'In Progress', width: 130, headerAlign: 'center', align: 'center',
      renderCell: (params) => (
        <Box sx={{ backgroundColor: '#fff6c2', width: '100%', height: '100%',
          display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {params?.value ?? '—'}
        </Box>
      ),
    },
    {
      field: 'nonAvviati', headerName: 'Non Avviati', width: 130, headerAlign: 'center', align: 'center',
      renderCell: (params) => (
        <Box sx={{ backgroundColor: '#fddede', width: '100%', height: '100%',
          display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {params?.value ?? '—'}
        </Box>
      ),
    },
    {
      field: 'total', headerName: 'Totale', width: 110, headerAlign: 'center', align: 'center',
      renderCell: (params) => (
        <Box sx={{ backgroundColor: '#e6f22694', width: '100%', height: '100%',
          display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {params?.value ?? '—'}
        </Box>
      ),
    },
{
      field: 'media', 
      headerName: '% Stato',
      width: 160,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const statoOriginale = params.row.stato;
        const mediaVal = params.row.media;

        let displayValue = '—';
        let bgColor = '#f5f5f5'; 

        if (statoOriginale === 'completed' || mediaVal === 100) {
          // Cambiato da 100.0% a 100%
          displayValue = '100%';
          bgColor = '#d0f2d5'; 
        } else if (typeof mediaVal === 'number') {
          displayValue = `${mediaVal.toFixed(1)}%`;
          bgColor = '#e6f22694'; 
        }

        return (
          <Box sx={{ 
            backgroundColor: bgColor, 
            width: '100%', 
            height: '100%',
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center' 
          }}>
            {displayValue}
          </Box>
        );
      },
    },
    {
      field: 'totAuto', headerName: 'Auto', width: 90, headerAlign: 'center', align: 'center',
      renderCell: (params) => params?.value ?? '—',
    },
  ], []);

const rows = React.useMemo(() => {
    const arr = Array.isArray(val) ? val : [];
    return arr.map((item, index) => {
      const hasNumeric =
        typeof item?.completati === 'number' ||
        typeof item?.inProgress === 'number' ||
        typeof item?.nonAvviati === 'number' ||
        typeof item?.totale === 'number';

      const completed  = hasNumeric ? (item?.completati ?? 0) : (item?.stato === 'completed' ? 1 : 0);
      const inProgress = hasNumeric ? (item?.inProgress ?? 0) : (item?.stato === 'in progress' ? 1 : 0);
      const nonAvviati = hasNumeric ? (item?.nonAvviati ?? 0) : (item?.stato === 'not started' ? 1 : 0);
      const total      = hasNumeric ? (item?.totale ?? (completed + inProgress + nonAvviati)) : 1;

      const name = item?.denominazione || item?.recapito || item?.nomeGarage || item?.garageName || 'N/D';
      const city = item?.citta || item?.localita || item?.comune || '—';

      return {
        id: item?.garageId || item?._id || index,
        garage: name,
        regione: item?.regione || '—',
        citta: city,
        completed,
        inProgress,
        nonAvviati,
        total,
        // Aggiungiamo lo stato originale e ricalcoliamo la media con precisione
        stato: item?.stato, 
        media: total > 0 ? (completed * 100) / total : 0,
        totAuto: item?.totAuto ?? item?.numero_auto ?? null,
      };
    });
  }, [val]);

  return (
    <Paper sx={{ width: '100%' }}>
      <DataGrid
        autoHeight
        rows={rows}
        columns={columns}
        getRowId={(r) => r.id}
        initialState={{
          pagination: { paginationModel },
          columns: {
            columnVisibilityModel: {
              garage: true, regione: true, citta: true,
              completed: true, inProgress: true, nonAvviati: true,
              total: true, percentage: true, totAuto: true,
            },
          },
        }}
        pageSizeOptions={[10, 15, 25, 50, 100]}
        density="compact"
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: { csvOptions: { fileName: `Depositi-${campaignName?.replace(/\s+/g, "_") || "Campagna"}` } },
        }}
        sx={{ border: 0 }}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
      />
    </Paper>
  );
}
